import { SectionBase } from "./SectionBase"
import { Section } from "./TextSection"
export interface IImageTextOption extends Section {}
export class ImageSection extends SectionBase {
  constructor(options: IImageTextOption) {
    super(options)
  }
  clone() {
    return new ImageSection(this.toJSON())
  }
  render(): HTMLDivElement {
    const parent = document.createElement('div')
    parent.classList.add('wrapper')
    const imgEl = document.createElement('img')
    imgEl.classList.add('section')
    imgEl.classList.add('image-section')
    imgEl.style.backgroundSize = 'contain'
    imgEl.style.position = 'absolute'
    // imgEl.style.overflow = 'auto'
    imgEl.textContent = 'Image Here'
    imgEl.ondragstart = () => false
    if (this.selected) {
      imgEl.classList.add('selected')
    }
    parent.appendChild(imgEl)
    return parent
  }
}
